import { Component, Input, OnInit } from "@angular/core";
import { OOVenue } from "src/app/shared/models/oo-venue";

@Component({
	selector: "app-venue-listing",
	templateUrl: "./venue-listing.component.html",
	styleUrls: ["../../public.style.scss"],
})
export class VenueListingComponent implements OnInit {
	@Input() ooVenue: OOVenue;
	constructor() {}

	ngOnInit(): void {}
}
